import { useMemo } from 'react';

import merge from 'lodash/merge';

import { GridWrapper } from '@nocowanie/common-ui';

import { CheckoutHeader } from '@app/components/molecules/checkout-header';
import { CheckoutNavbar } from '@app/components/molecules/checkout-navbar';
import { ProgressStepper } from '@app/components/molecules/progress-stepper';
import { commonUiStateSlice, useAppSelector } from '@app/state';

import { CheckoutPageLayoutProps } from './checkout-page-layout.props';

export const CheckoutPageLayout = ({
    activeStep,
    children,
    heading,
    reservationVariant,
    stickyBar,
    navbarProps = {},
}: CheckoutPageLayoutProps) => {
    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);
    const stepper =
        reservationVariant && activeStep ? (
            <ProgressStepper reservationVariant={reservationVariant} activeStep={activeStep} />
        ) : null;

    const navbarPropsMerged = useMemo(() => {
        // match mobile AppHeader styles,
        const navbarStyles = isMobileBrowser
            ? {
                  borderBottom: '1px solid {colors.border}',
                  mt: 0,
                  minH: '65px',
                  display: 'flex',
                  alignItems: 'center',
              }
            : {};

        const navbarCommonProps = {
            backButtonProps: {
                minWidth: undefined,
                variant: 'ghost',
                mr: 0,
                ml: -4,
            },
            headingProps: {
                fontSize: 'md',
            },
            ...navbarStyles,
        };

        return merge({}, navbarCommonProps, navbarProps);
    }, [isMobileBrowser, navbarProps]);

    return (
        <>
            <CheckoutNavbar {...navbarPropsMerged}>
                {isMobileBrowser ? null : stepper}
            </CheckoutNavbar>
            {isMobileBrowser ? stepper : null}
            {heading ? <CheckoutHeader heading={heading} /> : null}
            <GridWrapper
                gridTemplateColumns={{
                    base: '1fr',
                    md: 'repeat(16, 1fr)',
                }}
                maxWidth={'oldContainerWidth'}
                py={3}
                rowGap={6}
                columnGap={6}
            >
                {children}
            </GridWrapper>
            {stickyBar}
        </>
    );
};
